import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TemplateService } from "../../../shared/services/template.service";
import * as _ from "lodash";
import { SubSink } from "subsink";
import { Subject } from "rxjs";

@Component({
    selector: "clone-template",
    templateUrl: "./modal-clone-template.component.html",
    standalone: false
})
export class ModalCloneTemplateComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        private templateService: TemplateService,
        private log: NbcLoggerService
    ) {}
    public onSync!: Subject<any>;
    sub = new SubSink();
    modalTitle = "Clone Template";
    submitted = false;
    defaultOrderBy = "name";
    defaultReverseSort = false;
    buAccess: any = {};

    timecards: any = [];
    queryContainer: any;
    templateToClone: any;
    allTemplates: any[] = [];
    showErrormsg = false;
    errorMsg = "";
    name = "";

    getQueryContainer() {
        return {
            query: this.templateService.getTemplateListQuery(
                this.buAccess.businessUnitId,
                null,
                null,
                null
            ),
        };
    }

    cloneTemplate() {
        this.showErrormsg = false;
        this.errorMsg = "";
        this.submitted = true;
        if (this.validate()) {
            if (!this.hasTemplateNameUsed()) {
                const templates = this.getNewTemplate();
                this.cloneTemplates(templates);
            } else {
                this.showErrormsg = true;
                this.errorMsg = "Template with same name already exists";
                this.submitted = false;
            }
        } else {
            this.showErrormsg = true;
            this.errorMsg = "Template Name is required";
            this.submitted = false;
        }
    }

    validate() {
        if (_.trim(this.name).length <= 0) {
            return false;
        }
        return true;
    }

    hasTemplateNameUsed() {
        return _.some(this.allTemplates, (o) => {
            return _.lowerCase(o.name) === _.lowerCase(this.name);
        });
    }

    getNewTemplate() {
        const template = {
            sourceTemplateId: this.templateToClone.id,
            name: this.name,
        };
        return template;
    }

    cloneTemplates(template) {
        this.templateService.cloneTemplate(template).subscribe({
            next: (result) => {
                this.log.trace("got results: " + JSON.stringify(result));
            },
            error: (err) => {
                this.log.error("got an error: " + JSON.stringify(err));
            },
        });
        //this.onSync.next();
        this.onSync.next(""); //TODO: Revisit
        this.bsModalRef.hide();
    }

    getTimesheetTemplates() {
        this.log.trace("Get Timesheet Template");
        this.queryContainer.query.sortByColumn = this.defaultOrderBy;
        this.queryContainer.query.isActive = "All";
        this.sub.sink = this.templateService
            .getTemplates(this.queryContainer.query)
            .subscribe({
                next: (result) => {
                    this.allTemplates = result.reference.items;
                },
                error: (err) => {
                    this.log.error(err);
                    this.log.showModalError(
                        "Unable to load the timesheet template at this time. Please try again later."
                    );
                },
            });
    }

    cancel() {
        this.log.trace("canceled modal");
        this.bsModalRef.hide();
    }

    ngOnInit() {
        this.onSync = new Subject();
        this.templateToClone = _.get(this, "template");
        this.buAccess = _.get(this, "userBuAccess");
        this.queryContainer = this.getQueryContainer();
        this.getTimesheetTemplates();
    }
}
